module.exports = __webpack_public_path__ + "static/media/financepic5@3x.8e1a4caa.png";